import {ManagerCalls} from '../components/ServiceCalls';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import ReservationReminders from '../components/ReservationReminders';
import TopNav from '../components/TopNav';
import LandingFooter from '../components/LandingFooter';
import { useEffect, useState } from 'react';
import { getLandingPageSettingsPublic } from '../services/landingPageSettings';
import { resolveAssetUrl } from '../utils/media';
import ResponsiveDashboardTables from '../components/ResponsiveDashboardTables';
import api from '../services/api';

const DEFAULT_LANDING = {
  palette: {
    primary: '#02142C',
    accent: '#FF7300',
    onPrimary: '#FFFFFF',
    background: '#FFFFFF',
    text: '#02142C',
    fontSecondary: '#FFFFFF'
  },
  contact: {},
  logo: {
    url: '',
    background: '',
    backgroundTransparent: false
  }
};

const DashboardLayout = () => {
  const location = useLocation();
  const [landing, setLanding] = useState(DEFAULT_LANDING);
  const [logoWidth, setLogoWidth] = useState(40);
  const [logoHeight, setLogoHeight] = useState(40);
  const [renewalAlert, setRenewalAlert] = useState(null);
  const role = useSelector((state) => state.auth.user?.role);
  const supervisor = useSelector(state=>state.auth.user?.staffModules?.includes('SUPERVISOR'));

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const data = await getLandingPageSettingsPublic();
        if (!active) return;
        setLanding({
          palette: data?.palette || {},
          contact: data?.contact || {},
          logo: {
            url: data?.logo?.url ? resolveAssetUrl(data.logo.url) : '',
            background: data?.logo?.background || '',
            backgroundTransparent: Boolean(data?.logo?.backgroundTransparent)
          }
        });
        setLogoWidth(data?.logo?.widthPx ?? 40);
        setLogoHeight(data?.logo?.heightPx ?? 40);
      } catch {
        if (!active) return;
        setLanding(DEFAULT_LANDING);
        setLogoWidth(40);
        setLogoHeight(40);
      }
    };
    load();
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (role !== 'SHOP_OWNER') { setRenewalAlert(null); return; }
    api.get('/billing/overview').then(({ data }) => setRenewalAlert(data.renewalAlert || null)).catch(() => {});
  }, [role, location.pathname]);

  const isProfilePage = location.pathname.startsWith('/dashboard/profile');
  const isSettingsPage = location.pathname.startsWith('/dashboard/settings');

  return (
    <div className="d-flex flex-column min-vh-100">
      <TopNav
        brandLogoUrl={landing.logo.url}
        brandLogoBackground={landing.logo.background}
        brandLogoTransparent={landing.logo.backgroundTransparent}
        brandLogoWidth={logoWidth}
        brandLogoHeight={logoHeight}
        landingPalette={landing.palette}
      />
      <div className={`app-page-content dashboard-content flex-grow-1 ${isProfilePage ? 'dashboard-content--profile' : ''}`}>
        <ResponsiveDashboardTables />
        {role === 'SHOP_OWNER' && renewalAlert && !isSettingsPage && <Alert variant={renewalAlert.severity} className="mx-3 mt-3 mb-0 d-flex flex-wrap justify-content-between align-items-center gap-3"><div><strong>Package renewal</strong><div>{renewalAlert.message}</div></div><Button as={Link} to="/dashboard/settings#plan-billing" size="sm" variant="dark">Renew package</Button></Alert>}
        <ReservationReminders />
        {(['SHOP_OWNER','SHOP_STAFF'].includes(role)||role==='SHOP_OPERATOR'&&supervisor)&&<ManagerCalls/>}<Outlet />
      </div>
      <LandingFooter
        palette={landing.palette}
        contact={landing.contact}
      />
    </div>
  );
};

export default DashboardLayout;
